import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Faq.css";

const faqs = [
  {
    question: "What is OFC?",
    answer:
      "OFC is a digital platform that helps people form meaningful, location-based social connections through a gamified mobile experience.",
  },
  {
    question: "Who can use OFC?",
    answer:
      "Anyone 18+ years old, especially international students and young professionals interested in expanding their social circles.",
  },
  {
    question: "Is OFC free?",
    answer:
      "Yes, OFC offers a freemium model with optional premium features for enhanced experiences and benefits.",
  },
  {
    question: "How does OFC ensure user safety?",
    answer:
      "OFC uses email and phone verification, a community review system, and content moderation to ensure safe and trusted interactions.",
  },
  {
    question: "How can businesses use OFC?",
    answer:
      "OFC offers tailored solutions for event organizers and companies to facilitate networking and engagement at events or within teams.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div style={{ width: "70%" }}>
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h3 onClick={() => toggle(index)} className="faq-question">
              {faq.question}
            </h3>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.div
                  className="faq-answer"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <div className="answer-content">{faq.answer}</div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
